import styled from "@emotion/styled";
import React from "react";

import { ModuleThemeType } from "@brexhq/shared/types/ModuleTheme";
import { SanityCreditCardBlockProps } from "@brexhq/shared/types/modules/BlockRowsModule/BlockRowItems";

import { CreditCardBlockAccordion } from "./components/CreditCardBlockAccordion";
import { CreditCardBlockDetails } from "./components/CreditCardBlockDetails";
import { CreditCardBlockHeader } from "./components/CreditCardBlockHeader";

type CreditCardBlockProps = {
  data: SanityCreditCardBlockProps;
  theme: ModuleThemeType;
};

const Wrapper = styled.div(({ theme }) => ({
  borderRadius: theme.borders.radius.default,
  border: `1px solid ${theme.colors.border.default}`,
  overflow: "hidden",
  marginTop: theme.spacing[24],
  marginBottom: theme.spacing[24],
  width: "100%",
}));

export const CreditCardBlock = ({ data, theme }: CreditCardBlockProps) => {
  const cta = "cta" in data ? data.cta : data.creditCardBlockCta;
  return (
    <Wrapper>
      <CreditCardBlockHeader
        title={data.title}
        image={data.image}
        description={data.description}
        htmlTagOverride={data.htmlTagOverride}
        creditCardBlockCta={cta}
        leadForm={data.leadForm}
      />

      <CreditCardBlockDetails details={data.details} />

      <CreditCardBlockAccordion accordion={data.accordion} theme={theme} />
    </Wrapper>
  );
};
